// extracted by mini-css-extract-plugin
export default {"popup_wrap":"auctionError_popup_wrap__425oC","popup_message":"auctionError_popup_message__EzdoD","popup_message_button":"auctionError_popup_message_button__zCVRx"};